import {ReactComponent as CoinplusIcon} from './coinplus.svg'

function Coinplus() {
  return <CoinplusIcon />
}

export default Coinplus
